"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const react_1 = require("@emotion/react");
const react_2 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const Spinner = (props) => {
    const { size = "md" } = props;
    const { diameter, border } = react_2.default.useMemo(() => {
        switch (size) {
            case "xxs":
                return { diameter: "spacing-5", border: "1px solid" };
            case "xs":
                return { diameter: "spacing-6", border: "1px solid" };
            case "sm":
                return { diameter: "spacing-7", border: "2px solid" };
            case "md":
                return { diameter: "spacing-8", border: "3px solid" };
            case "lg":
                return { diameter: "spacing-9", border: "3px solid" };
            case "xl":
                return { diameter: "spacing-10", border: "3px solid" };
        }
    }, [size]);
    const spin = (0, react_1.keyframes)({
        from: { transform: "rotate(0deg)" },
        to: { transform: "rotate(360deg)" }
    });
    const spinStyles = {
        border,
        borderTop: border,
        borderColor: "surface-brand-teriary",
        borderTopColor: "onSurface-brand-primary",
        borderRadius: "radius-round",
        width: diameter,
        height: diameter,
        transform: "rotate(360deg)",
        animation: `${spin} 2s linear infinite`
    };
    return react_2.default.createElement(foundations_1.Box, { sx: Object.assign({}, spinStyles) });
};
exports.Spinner = Spinner;
//# sourceMappingURL=Spinner.js.map